import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils/numberFormat";
import "./AIEmailEditor.scss";

type StepProgressProps = {
  current: number; 
  total: number;   
};

const StepProgress: React.FC<StepProgressProps> = ({ current, total }) => {
  const { t, i18n } = useTranslation();
  const safeCurrent = Math.min(Math.max(current, 1), total);
  const percent = (safeCurrent / total) * 100;

  return (
<div className="progress-header">
  <div className="progress-top">
    <span className="progress-title">{t("campaignFlow.aiEmailEditor.progressTitle")}</span>
    <span className="progress-step">
      {t("campaignFlow.aiEmailEditor.stepOf", {
        step: formatNumber(safeCurrent, {}, i18n.language),
        total: formatNumber(total, {}, i18n.language),
      })}
    </span>
  </div>

  <div className="progress-track">
    <div
      className="progress-fill"
      style={{ width: `${percent}%` }}
    />
  </div>
</div>

  );
};

export default StepProgress;
